import { AppEnum, AppEnumHelper, DOMAIN_TYPES, OptionHelper, PermissionEnums, USER_ROLES } from "@/Shared";
import { PermissionFormValues } from "../PermissionFormValidation";
import { PermissionModel } from "../Models/PermissionModel";
import { ResourceAccessModel } from "../Models";

export class PermissionFormViewModel {
	public id!: number;
	public role!: string;
	public resourceAccessList!: Record<string, Record<string, boolean>>;
	constructor(
		private viewEnums: PermissionEnums,
		private _permission?: PermissionModel) {
	
		this.init(this._permission);
	}

	private init(permission?: PermissionModel) {
		this.id = permission?.id ?? 0;
		this.role = permission?.role ?? USER_ROLES.USER;


		const resources: Record<string, Record<string, boolean>> = {};

		this.resourceOptions.forEach(resourceEnum => {
			const domain = resourceEnum.value;
			const resourceAccess = permission?.resourceAccessList?.find(ra => ra.resource === domain)
				?? { resource: domain } as ResourceAccessModel;

			const rights: Record<string, boolean> = {
				'allRecords' :  resourceAccess.allRecords ?? false 
			};

			this.accessOptions.forEach(accessEnum => {
				const key = accessEnum.value
				rights[key] = resourceAccess.rightList?.includes(key as string) ?? false;
			});

			resources[resourceAccess.resource] = rights;
		});

		this.resourceAccessList = resources;
	}

	getAccessRightLabel(right: string) {
		return AppEnumHelper.getLabel(this.viewEnums.AccessTypeEnum, right);
	}

	getRoleLabel(role: string) {
		return AppEnumHelper.getLabel(this.viewEnums.UserRoleEnum, role);
	}

	getResourceLabel(res: string) {
		return AppEnumHelper.getLabel(this.viewEnums.ResourceTypeEnum, res);
	}


	get formValues(): PermissionFormValues {
		return {
			id: this.id,
			role: this.role,
			resourceAccessList: this.resourceAccessList,
		} as PermissionFormValues;
	}

	getTitle(): string {
		return this.id > 0
			? `Permission N° ${this.id}`
			: "Création de Permission";
	}

	isCreationMode(): boolean {
		return !this.id;
	}


	get roleOptions(): AppEnum[] {
		return OptionHelper.sortByLabel(
			(this.viewEnums.UserRoleEnum ?? [])
			.filter(rEnum => rEnum.value !== USER_ROLES.SUPER_ADMIN)
		);
	}

	get resourceOptions(): AppEnum[] {
		const resOptions = this.viewEnums.ResourceTypeEnum ?? [];
		return OptionHelper.sortByLabel(
			(this.role === USER_ROLES.SUPER_ADMIN) 
			? resOptions
			: resOptions.filter(
				resOpt => ![DOMAIN_TYPES.Permission, DOMAIN_TYPES.User]
					.includes(resOpt.value as DOMAIN_TYPES)
			)
		);
	}

	get accessOptions(): AppEnum[] {
		return OptionHelper.sortByLabel(this.viewEnums.AccessTypeEnum);
	}
}
